import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import styles from './ToggleInput.module.scss';

const ToggleInput: FC<IProps> = (props) => {
    const onClick = (e) => {
        e.stopPropagation();

        if (props.isDisabled) {
            return;
        }

        props.onChangeValue?.(!props.value);
    };

    return (
        <div
            className={
                classNames(styles.toggleInput, props.className, {
                    [styles.isActive]: props.value,
                    [styles.isDisabled]: props.isDisabled,
                })
            }
        >
            {
                props.label &&
                <div className={styles.title}>
                    {props.label}
                </div>
            }
            <div
                className={styles.toggle}
                onClick={onClick}
            >
                <div className={styles.value}/>
            </div>
        </div>
    );
};

export default ToggleInput;
